<cc-settings-block>
  <cc-settings-header header="PHONE.USERS.HEADER"></cc-settings-header>
  <cc-settings-body>

    <a (click)="goToInviteUser()" class="invite-link">
      <span translate>PHONE.USERS.ADD</span>
    </a>

    <div class="options">
      <i class="material-icons">search</i>
      <input class="form-control"
             #search
             [placeholder]="'SEARCH' | translate"
             (input)="filterUsers(search.value)"
      >

      <div class="select-all">
        <span class="" translate>REPORTS.SELECT_ALL</span>
        <mat-checkbox
          [formControl]="selectAllUsersCheckbox"
          [indeterminate]="selectAllUsersCheckbox.value === null"
          (ngModelChange)="changeSelectAllState($event)">
        </mat-checkbox>
      </div>
    </div>

    <div class="checkbox-wrapper">
      <div *ngFor="let user of filteredUsers" class="checkbox-item">
        <mat-checkbox (change)="changeUsersForEvent($event)"
                      [value]="user"
                      [checked]="isChecked(user)">
        </mat-checkbox>
        <cc-user [user]="user"></cc-user>
      </div>
    </div>

    <div class="button-wrapper">
      <button class="btn info-full" (click)="save()" translate>SAVE</button>
    </div>

  </cc-settings-body>
</cc-settings-block>
